// Interface pour la réponse Cloudinary
export interface CloudinaryResponse {
  public_id: string;
  width: number;
  height: number;
  format: string;
  created_at: string;
  resource_type: string;
  tags: string[];
  bytes: number;
  type: string;
  etag: string;
  placeholder: boolean;
  url: string;
  secure_url: string;
  signature: string;
  original_filename: string;
}

// Service d'upload Cloudinary sécurisé avec signature
// Cette fonction permet d'uploader un fichier sur Cloudinary en obtenant d'abord une signature sécurisée depuis un backend (ici un Worker Cloudflare)
export async function uploadToCloudinary(file: File): Promise<CloudinaryResponse> {
  // 1. Appel au backend pour obtenir la signature Cloudinary
  // L'URL pointe vers le Worker Cloudflare qui génère la signature à la volée
  const sigRes = await fetch('https://cloudinary-signature-worker.arsonbahman.workers.dev/api/cloudinary-signature');
  if (!sigRes.ok) {
    // Gestion d'erreur si la signature n'est pas récupérée correctement
    console.error('Erreur lors de la récupération de la signature Cloudinary:', sigRes.status, await sigRes.text());
    throw new Error("Impossible d'obtenir la signature Cloudinary");
  }
  // On récupère la signature, le timestamp et la clé API depuis la réponse du Worker
  const { signature, timestamp, apiKey } = await sigRes.json();
  console.log('Signature Cloudinary reçue:', { signature, timestamp, apiKey });

  // 2. Construction de l'URL d'upload Cloudinary
  // Le nom du cloud est récupéré depuis les variables d'environnement Vite (à configurer dans .env)
  const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME; // ⚠️ Attention : ce code suppose que la variable est bien définie
  const url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;

  // 3. Préparation du formulaire d'upload
  // On ajoute le fichier, la clé API, le timestamp et la signature au FormData
  const formData = new FormData();
  formData.append('file', file);
  formData.append('api_key', apiKey);
  formData.append('timestamp', timestamp);
  formData.append('signature', signature);

  // 4. Envoi de la requête d'upload à Cloudinary
  const response = await fetch(url, {
    method: 'POST',
    body: formData,
  });

  // 5. Traitement de la réponse Cloudinary
  const data = await response.json();
  if (!response.ok) {
    // Gestion d'erreur si l'upload échoue
    console.error('Erreur Cloudinary:', data);
    throw new Error(data.error?.message || 'Erreur lors de l\'upload Cloudinary');
  }

  // 6. Retourne toutes les métadonnées de la photo uploadée
  console.log('Réponse Cloudinary:', data);
  return data as CloudinaryResponse;
} 